import { useEffect, useState } from 'react';
import { IoArrowUp } from 'react-icons/io5';

import { ActionIcon, Affix, Transition } from '@mantine/core';
import { useHeadroom } from '@mantine/hooks';

import { useScroll } from 'hooks/dom/use-scroll';

import cx from './ScrollToTop.module.scss';

const ScrollToTop = () => {
    const scrollUp = useHeadroom();
    const { top: scroll, scroll: scrollTo } = useScroll();

    const [offset, setOffset] = useState(200);

    useEffect(() => {
        const hero = document.querySelector('[data-hero]');

        if (hero) {
            setOffset(hero.getBoundingClientRect().height + 20);
        }
    }, []);

    const mounted = scrollUp && scroll > offset;

    return (
        <Affix className={cx.root}>
            <Transition transition="slide-up" mounted={mounted}>
                {(transitionStyles) => (
                    <ActionIcon size="lg" style={{ ...transitionStyles }} onClick={() => scrollTo(0)} radius={99}>
                        <IoArrowUp size={16} />
                    </ActionIcon>
                )}
            </Transition>
        </Affix>
    );
};

export { ScrollToTop };
